<template>
  <div v-if="isHasChannels" class="channel-area-filter">
    <div v-if="showTitle" class="channel-title font-semibold">
      {{ filterTitle }}
    </div>
    <div class="channel-filter font-medium">
      <ul v-if="hasChannelGroups" class="channel-department-list">
        <li
          v-for="(item, index) in channelGroups"
          :key="item.id"
          class="hover-transition-text hover-transition-linear channel-item department-item"
          :class="{'actived': selectedChannelGroupIndex == index}"
          @click="changeGradeStage(index, item)"
          @mouseenter="addClass(index)"
          @mouseleave="removeClass"
        >
          <img v-if="item.iconUrl" class="icon" v-lazy-load :data-src="`${ (selectedChannelGroupIndex === index||hover === index)?item.iconUrl:item.unIconUrl}`">
          {{ item.name }}
        </li>
      </ul>
      <ul v-if="hasChannelGroups" class="channel-list">
        <li
          v-for="item in channelGroups[selectedChannelGroupIndex].channels"
          :key="item.id"
          class="hover-transition-text hover-transition-linear channel-item channel-list-item"
          :class="{'actived':selectedChannelId == item.id}"
          @click="changeGrade(item)"
        >
          {{ item.name }}
        </li>
      </ul>
      <ul v-else class="channel-list">
        <li
          v-for="item in channels"
          :key="item.id"
          class="hover-transition-text hover-transition-linear channel-item channel-list-item"
          :class="{'actived':selectedChannelId == item.id}"
          @click="changeGrade(item)"
        >
          {{ item.name }}
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { oneApi } from 'config/api'
import { getMallChannelByLocation } from 'common/map.js';

export default {
  props: {
    location: {
      default: '',
      type: String,
    },
    showTitle: {
      default: true,
      type: Boolean,
    },
    defaultSelectedChannelId: {
      default: '',
      type: String,
    },
  },
  data() {
    return {
      filterTitle: '',
      isHasChannels: true,
      channelGroups: [],
      channels: [],
      defaultChannelId: '',
      selectedChannelGroupIndex: 0,
      selectedChannelId: '',
      hover: null,
      departListIcon: ['icon-preschool-department', 'icon-primary-department', 'icon-junior-department', 'icon-higher-department'],
    }
  },
  computed: {
    hasChannelGroups() {
      return Array.isArray(this.channelGroups) && this.channelGroups.length > 0
    },
    hasChannels() {
      return Array.isArray(this.channels) && this.channels.length > 0
    },
  },
  watch: {
    selectedChannelId() {
      this.$emit('channel-change', this.selectedChannelId)
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    addClass(val) {
      this.hover = val
    },
    removeClass() {
      this.hover = null
    },
    // 数据初始化
    async init() {
      await this.queryFilters();
      this.initSelectedChannel();
    },
    // 选择频道
    changeGrade(channel) {
      this.selectedChannelId = channel.id
      this.channelClickHandler(channel)
    },
    // 选择频道组
    changeGradeStage(index, item) {
      // 默认切换当前选中频道为第一个
      this.selectedChannelGroupIndex = index
      if (item.channels && Array.isArray(item.channels) && item.channels.length > 0) {
        this.selectedChannelId = item.channels[0].id
      }
    },
    // 请求频道list
    async queryFilters() {
      const data = {
        mallGroup: getMallChannelByLocation(this.location),
      }
      const res = await this.$axios.post(oneApi.getChannel, data, { rewritePostBody: true })
      // 业务异常阻断
      if (res.code !== 0) {
        this.$emit('has-channel', false)
        return
      }
      const resData = res.data || {}
      this.filterTitle = resData.selectorTitle || ''
      this.defaultChannelId = resData.defaultChannelId || ''
      if (resData.channelGroups) {
        this.channelGroups = resData.channelGroups || []
        this.channelGroups = this.channelGroups.filter((group) => Array.isArray(group.channels) && group.channels.length > 0)
        this.isHasChannels = this.hasChannelGroups
      } else if (resData.channels) {
        this.channels = resData.channels
        this.isHasChannels = this.hasChannels
      } else {
        this.channelGroups = []
        this.channels = []
        this.isHasChannels = false
      }

      this.$emit('has-channel', this.isHasChannels)
    },
    // 初始化当前选中频道
    initSelectedChannel() {
      // 外部传入默认选中项
      if (this.defaultSelectedChannelId) {
        this.selectedChannelGroupIndex = this.getChannelGroupIndexByChannelId(this.defaultSelectedChannelId)
        if (this.selectedChannelGroupIndex >= 0) {
          this.selectedChannelId = this.defaultSelectedChannelId
          return
        }
      }
      // 接口返回权重最大的频道id
      if (this.defaultChannelId) {
        this.selectedChannelGroupIndex = this.getChannelGroupIndexByChannelId(this.defaultChannelId)
        if (this.selectedChannelGroupIndex >= 0) {
          this.selectedChannelId = this.defaultChannelId
          return
        }
      }
      // 默认选中第一个频道
      if (this.hasChannelGroups) {
        this.selectedChannelGroupIndex = 0
        const firstChannels = this.channelGroups[0].channels || []
        if (firstChannels.length === 0) return
        this.selectedChannelId = firstChannels[0].id || ''
        return
      }
      if (this.hasChannels) {
        this.selectedChannelId = this.channels[0].id || ''
      }
    },
    getChannelGroupIndexByChannelId(channelId) {
      if (!channelId || !this.hasChannelGroups) return -1
      for (let i = 0; i < this.channelGroups.length; i += 1) {
        const resultChannels = this.channelGroups[i].channels.filter((channel) => `${channel.id}` === `${channelId}`)
        if (Array.isArray(resultChannels) && resultChannels.length > 0) return i
      }
      return -1
    },
    // 神策埋点-频道点击事件
    channelClickHandler(channel) {
      const previousSource = this.getChannelSource(this.location)
      if (!previousSource) return;
      this.Sensors.track('courses_channel_click', {
        channel_name: channel.name,
        previous_source: this.getChannelSource(this.location),
      })
    },
    // 频道来源映射
    getChannelSource(location) {
      const locationMap = new Map([
        ['courses-mall', 'courses'],
        ['competition-mall', 'competititon'],
        ['resources', 'free-resources'],
      ])

      return locationMap.get(location)
    },
  },
}
</script>

<style lang="scss" scoped>
.channel-area-filter {
  width: 1160px;
  padding: 24px 50px 4px;
  margin: 24px auto 0;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 3px 6px 4px rgba(190, 194, 201, 0.06), 0 2px 4px 0 #fff inset, 0 -2px 4px 0 rgba(205, 214, 232, 0.3) inset;

  .channel-title {
    margin-bottom: 20px;
    text-align: center;
    font-size: 24px;
    color: var(--txt-color-lv1);
    line-height: 29px;
  }

  ul {
    padding: 0;
    list-style: none;
    flex-wrap: wrap;
  }

  .channel-filter {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .channel-department-list,
  .channel-list {
    display: flex;
    justify-content: center;
  }

  .channel-item {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    margin: 0 20px 20px 0;
    padding: 8px 16px;
    width: 160px;
    height: 40px;
    text-align: center;
    vertical-align: middle;
    box-sizing: border-box;
    font-size: 16px;
    line-height: 24px;
    background: var(--txt-color-link3);
    border-radius: 20px;
    color: var(--txt-color-link);
    cursor: pointer;
    transition: background 0.2s linear;

    .icon {
      margin-right: 2px;
      vertical-align: middle;
      width: 24px;
      height: 24px;
    }

    &:last-child {
      margin-right: 0;
    }

    &:hover {
      background: var(--txt-color-link4);
    }

    &.actived {
      background: var(--txt-color-link);
      color: #fff;
    }
  }
}
</style>
